"use client";

import { ProjectCard } from "@/components";
import { projects } from "@/util";

export const Projects = () => (
  <div id="projects" className="section !pb-20 md:!pb-40">
    <div className="first-letter:capitalize tracking-tight text-2xl md:text-3xl lg:text-6xl">
      projects
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 mt-5 md:mt-10">
      {projects.map(({ id, ...props }) => (
        <ProjectCard key={id} {...props} />
      ))}
    </div>
  </div>
);
